import React from 'react';
import { Route, Routes } from 'react-router-dom';

import ProductEndOfLife from '../../modules/shared/pages/ProductEndOfLife/ProductEndOfLife';

const InstructorRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<ProductEndOfLife title="Instructor Portal" />} />
    </Routes>
  );
};

export default InstructorRoutes;
